import React, { useState, useEffect } from 'react';
import * as qf from '../misc/qf';

const DeleteMediaBtn = ({ media, el }) => {
  const [showDeleteBtn, setShowDeleteBtn] = useState(false);
  const [contextLinks, setContextLinks] = useState(undefined);

  const deleteMedia = () => {
    qf.deleteJSON(contextLinks._links.delete.href)
      .then( res => {
        console.log(res)
        window.location.href = media._links.gallery.href;
      })
      .catch( err => console.error(err) );
  };

  useEffect( () => {
    qf.getJSON(media._links.context_actions.href)
      .then( res => {
        if (!res._links.delete) {
          el.remove();
        } else {
          setContextLinks(res);
          setShowDeleteBtn(true);
        }
      })
      .catch( err => console.error(err));
  }, [])

  if (!showDeleteBtn) {
    return (<></>)
  };

  return (
    <a onClick={deleteMedia}>
      <i className="fa fa-times"></i> Delete Media
    </a>
  )
}

export default DeleteMediaBtn;
